export class ChangeOrganisation {
  static readonly type = '[User] ChangeCurrentOrganisation';

  constructor(public currentOrganisation: string) { }
}
